module.exports = __webpack_public_path__ + "6a91f475a42ca28ddbdf7446244884c1.fbx";